module.exports = __webpack_public_path__ + "static/media/1-min.763fb497.jpeg";